<script>
export default {
    name: 'DashboardCard',
};
</script>

<template>
    <div class="panel panel-default dashboard-widget-panel">
        <div class="panel-heading">
            <h3 class="panel-title">
                <slot name="header" />
            </h3>
        </div>
        <div class="panel-body dashboard-card-body">
            <slot name="content" />
        </div>
        <div v-if="$slots.footer" class="panel-footer dashboard-card-footer text-right">
            <slot name="footer" />
        </div>
    </div>
</template>
